export class CashRegisterLoginLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 